<template>
  <!-- Sans restriction-->
  <img v-if="'d1f021c6-2354-44b0-be19-340cee0dadb5' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/culture.png">
  <!-- Culture-->
  <img v-if="'15c786e0-9eba-4434-872a-081465529704' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/culture.png">
  <!-- Noël-->
  <img v-if="'4d1a680f-c4a4-4ac0-9c10-7c150de44741' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/noel.png">
  <!-- Vacances/Voyages-->
  <img v-if="'efb949f8-3423-42f7-b98c-5ed68d8d1da5' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/voyages.png">
  <!-- Rentrée scolaire-->
  <img v-if="'7a7d6425-a28e-4882-8fc0-1a3da9fa0049' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/rentree_scolaire.png">
  <!-- Retraite-->
  <img v-if="'056a7b93-dbc7-46ef-b4aa-50a23a0b8e81' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/retraite.png">
  <!-- Naissance-->
  <img v-if="'0b4d4ca7-24fc-4b4f-9f57-965b22ccc15f' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/naissance.png">
  <!-- Mariage-->
  <img v-if="'9e1bfdf9-b432-41ac-abcb-d9b90c561425' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/mariage.png">
  <!-- Sport-->
  <img v-if="'e5e775de-4d43-48ae-a91d-596d8d9c5281' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/sport.png">
  <!-- Fête des mères/pères-->
  <img v-if="'89de6b06-0aad-4b8f-8653-477010f144b9' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/fete_des_meres.png">
  <!-- Sainte-Catherine/Saint-Nicolas-->
  <img v-if="'a3762c0e-3874-4e63-a815-1cf8bfc23d08' === props.event.uuid" class="campaign-event-icon-image" src="@/assets/img/campaign_event_icon/3D/saint_nicolas.png">
</template>

<script setup>
  const props = defineProps({
    'event': {
      type: Object,
      default: () => ({
        name: null,
        uuid: null,
      })
    }
  })
</script>

<style scoped lang="scss">

</style>
